module.exports = __webpack_public_path__ + "media/images/landing/ar/save_time-4d4bf954641569ca22b96e193496f84f.png";